import React from "react";
import { CircleNotch, CloudSlash, ArrowClockwise } from "@phosphor-icons/react";
import { timeAgo } from "@/lib/showsCache";

export const ConnectionStatus = ({ status, cachedAt, onRetry }) => {
  if (status === "reconnecting") {
    return (
      <div
        data-testid="reconnecting-indicator"
        role="status"
        className="mb-6 inline-flex items-center gap-2 rounded-full border border-amber-400/25 bg-amber-400/[0.07] px-3.5 py-1.5 text-xs font-medium text-amber-200"
      >
        <CircleNotch size={13} className="animate-spin" /> Reconnecting…
        {cachedAt && <span className="text-amber-200/60">· showing saved results from {timeAgo(cachedAt)}</span>}
      </div>
    );
  }
  if (status === "offline") {
    return (
      <div
        data-testid="offline-indicator"
        role="status"
        className="mb-6 inline-flex flex-wrap items-center gap-2 rounded-full border border-white/15 bg-white/[0.04] px-3.5 py-1.5 text-xs text-slate-300"
      >
        <CloudSlash size={14} className="text-slate-400" />
        {cachedAt ? `Connection lost · showing saved results from ${timeAgo(cachedAt)}` : "Connection lost"}
        <button
          data-testid="connection-retry-btn"
          onClick={onRetry}
          className="inline-flex items-center gap-1 font-semibold text-blue-400 transition-colors hover:text-blue-300"
        >
          <ArrowClockwise size={12} /> Retry
        </button>
      </div>
    );
  }
  return null;
};
